import hasVariantByIdInCartSelector from 'modules/cart/redux/selectors/has-variant-by-id-in-cart'
import { createSelector } from 'reselect'
import isSelectedVariantOutOfStockVariantSelect from 'modules/variant/redux/selectors/is-selected-variant-out-of-stock'
import getAmountGiftSelect from 'modules/gift/redux/selectors/get-amount'
import getGiftCardItemCartSelect from 'modules/cart/redux/selectors/get-gift-card'
import getByVariantIdAddLabelSelectorUtil from 'modules/product/redux/selectors/get-by-variant-id-add-label/utils'
import isUnlockedProductVariantSelector from 'modules/product/redux/selectors/is-unlocked'
import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'
import hasSampledVariantSelector from 'modules/variant/redux/selectors/has-sampled'
import hasSampledAndRatedVariantSelector from 'modules/variant/redux/selectors/has-sampled-and-rated'
import isGiftUrlLocationUtil from 'utils/location/is-gift-url'
import isAvailableByIdVariantSelector from 'modules/variant/redux/selectors/is-available-by-id'
import isProductUrlLocationUtil from 'utils/location/is-product-url'
import shouldShowQuickShadesProductVariantSelector from 'modules/product-variant/redux/selectors/should-show-quick-shades'
import { shouldShowAOVLockProductVariantSelector } from 'modules/product-variant/redux/selectors/should-show-aov-lock'

/**
 * @param props
 * @param {ProductVariantCollection} props.productVariant
 * @param {ProductVariantCollection} props.featuredProductVariant
 * @param props.variantId
 * @param props.isLoading
 * @param props.price
 * @param props.isFromSidebar
 * @param props.isGiftCard
 * @param props.isFromGrid
 * @param props.isSmallScreen
 * @param props.isAvailable
 * @param props.hasExpressCheckout
 * @param props.discountPrice
 * @return {*}
 */
export default function getByVariantIdAddLabelSelector (props) {
  const {
    productVariant,
    featuredProductVariant,
    variantId,
    isLoading,
    price,
    isFromSidebar,
    isGiftCard,
    isFromGrid,
    isSmallScreen,
    hasExpressCheckout,
    discountPrice,
    shouldShowVariants = true,
    needsToBeRatedSample = false,
    isExtraExtraSmallScreen
  } = props

  return createSelector(
    hasVariantByIdInCartSelector(variantId),
    isSelectedVariantOutOfStockVariantSelect,
    getAmountGiftSelect,
    getGiftCardItemCartSelect,
    isUnlockedProductVariantSelector({ productVariant }),
    isAvailableByIdVariantSelector(variantId),
    hasSampledVariantSelector(variantId),
    hasSampledAndRatedVariantSelector(variantId),
    shouldShowQuickShadesProductVariantSelector({
      featuredProductVariant,
      isExtraExtraSmallScreen
    }),
    shouldShowAOVLockProductVariantSelector({
      productVariant
    }),
    (
      isInCart,
      isSelectedVariantOutOfStock,
      amount,
      giftCardItem,
      isUnlocked,
      isAvailableState,
      hasSampled,
      hasSampledAndRated,
      shouldShowQuickShades,
      shouldShowAOVLock
    ) => {
      return getByVariantIdAddLabelSelectorUtil({
        isAvailableState,
        shouldShowAOVLock,
        isAvailable: props.isAvailable,
        shouldShowQuickShades,
        isGifting: isGiftUrlLocationUtil(),
        productVariant,
        isSelectedVariantOutOfStock,
        isLoading,
        isInCart,
        price,
        isFromSidebar,
        isGiftCard,
        amount,
        giftCardItem,
        isFromGrid,
        isUnlocked,
        isSmallScreen,
        hasExpressCheckout,
        isSelfGifting: isSelfGiftingUrlLocationUtil(),
        hasSampled,
        hasSampledAndRated,
        discountPrice,
        shouldShowVariants,
        needsToBeRatedSample,
        isProductUrlLocation: isProductUrlLocationUtil()
      })
    }
  )
}
